<template>
  <div>
    <a-drawer :width="880" :body-style="{ paddingBottom: '80px' }" :visible="visible" @close="close">
      <a-skeleton v-if="loading" active />
      <div v-else>
        <div class="case-detail">
          <a-descriptions size="small" :column="3">
            <span slot="title">
              <span>{{ taskData.name }}</span>
              <span class="description_subtitle">#{{ taskData.key }}</span>
              <a-divider />
            </span>
            <a-descriptions-item label="状态">
              <a-tag v-if="taskStatus[taskData.status]" :color="taskStatus[taskData.status].color">{{ taskStatus[taskData.status].label }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="类型">
              <span v-if="taskData.objective.length > 0">
                <a-tag v-for="(item, index) in taskData.objective" :key="index" :color="item.color">{{ item.name }}</a-tag>
              </span>
            </a-descriptions-item>
            <a-descriptions-item label="优先级">
              <a-tag :color="taskPrioritys[taskData.priority].color">{{ taskPrioritys[taskData.priority].label }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="负责人">
              <span v-if="taskData.handlers && taskData.handlers.length > 0">
                <span v-for="user in users(taskData.handlers)" :key="user.id">
                  <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                </span>
              </span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="已评审">
              <a-tag v-if="taskData.is_review === 0" color="green">是</a-tag>
              <a-tag v-else color="blue">否</a-tag>
            </a-descriptions-item>
            <a-descriptions-item v-if="taskData.version" label="所属迭代"> {{ taskData.version.name || null }} </a-descriptions-item>
            <a-descriptions-item label="开始时间"> {{ taskData.start_time || '--' }}</a-descriptions-item>
            <a-descriptions-item label="结束时间"> {{ taskData.end_time || '--' }}</a-descriptions-item>
            <a-descriptions-item v-if="taskData.creator" label="创建人">{{ taskData.creator.nickname }} </a-descriptions-item>
            <a-descriptions-item label="创建时间"> {{ taskData.created_time }}</a-descriptions-item>
            <a-descriptions-item label="更新时间"> {{ taskData.updated_time }}</a-descriptions-item>
          </a-descriptions>
          <a-tabs v-model="tabsCurrent" default-active-key="1" size="small">
            <a-tab-pane key="1" tab="详细信息">
              <EditorPreview :content="taskData.description" />
            </a-tab-pane>
          </a-tabs>
        </div>
        <div style="padding-top: 2px">
          <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">任务评审</span></a-divider>
          <a-descriptions :column="3" size="small">
            <a-descriptions-item label="评审结果(上次)">
              <review-case-result-edit :disabled="true" :review-id="reviewId" :case-id="taskData.id" :result="taskData.result" />
            </a-descriptions-item>
            <a-descriptions-item label="评审时间(上次)">
              <span v-if="taskData.result !== 1">{{ taskData.reviewTime }}</span>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="评审人员(上次)">
              <span v-if="taskData.result !== 1">{{ taskData.reviewer ? taskData.reviewer.nickname : '--' }}</span>
              <span v-else>--</span>
            </a-descriptions-item>
          </a-descriptions>
          <a-textarea v-model="resultComment" placeholder="评审结果备注" :auto-size="{ minRows: 3, maxRows: 6 }" />
        </div>
      </div>
      <div class="review-handle">
        <a-button type="dashed" :disabled="!hasBefore" style="margin-right: 10px" @click="onBeforeTask">
          <a-icon type="left" />
          上一条
        </a-button>
        <a-button type="dashed" :disabled="!hasNext" style="margin-right: 10px" @click="onNextTask">
          下一条
          <a-icon type="right" />
        </a-button>
        <a-tooltip>
          <template slot="title"> 评审结果置为"已评审"并加载下一条 </template>
          <a-button type="primary" class="pass-btn" @click="onTaskReviewed"> 已评审 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 评审结果置为"待更新"并加载下一条 </template>
          <a-button type="danger" @click="onTaskNeedUpdate"> 待更新 </a-button>
        </a-tooltip>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import EditorPreview from '@/components/EditorPreview';
import { taskStatus, taskPrioritys } from '@/utils/dictionary';
import { reviewTaskDetail, updateReviewItemResult } from '@/api/project/review';
import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => index + 1
  },
  {
    title: '操作步骤',
    dataIndex: 'step',
    key: 'step'
  },
  {
    title: '预期结果',
    dataIndex: 'result',
    key: 'result'
  }
];
export default {
  components: { ReviewCaseResultEdit, EditorPreview },
  props: {
    objectId: {
      type: Number,
      default: null
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      taskPrioritys,
      loading: true,
      visible: false,
      taskId: null,
      reviewId: parseInt(this.$route.query.reviewId) || null,
      taskData: {},
      projectId: parseInt(this.$route.params.project_id) || null,
      size: 'small',
      resultComment: '',
      tabsCurrent: '1'
    };
  },
  computed: {
    users() {
      return items => {
        return items || [];
      };
    }
  },
  watch: {
    objectId() {
      this.taskId = this.objectId;
      if (this.taskId !== null) {
        this.getTaskDetail();
      }
    }
  },
  methods: {
    onOpen(taskId) {
      this.visible = true;
      this.taskId = taskId;
      if (this.taskId !== null) {
        this.getTaskDetail();
      }
    },
    // 获取任务详情
    getTaskDetail() {
      reviewTaskDetail({ project_id: this.projectId, review_id: this.reviewId, task_id: this.taskId })
        .then(res => {
          this.taskData = res.data;
          this.resultComment = res.data.resultComment;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.visible = false;
      this.$emit('close');
    },
    onTaskReviewed() {
      this.updateReviewTaskResult(3, this.resultComment);
    },
    onTaskNeedUpdate() {
      this.updateReviewTaskResult(4, this.resultComment);
    },
    onNextTask() {
      this.$emit('next');
    },
    onBeforeTask() {
      this.$emit('before');
    },
    updateReviewTaskResult(result, description) {
      updateReviewItemResult({
        review_id: this.reviewId,
        result: result,
        item_id: this.taskId,
        description: description
      }).then(() => {
        this.$message.success('结果更新成功');
        this.$emit('next');
      });
    }
  }
};
</script>
<style lang="less" scoped>
.case-detail {
  overflow-y: auto;
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0px;
}

.description_subtitle {
  margin-left: 8px;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

/deep/ .drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.pass-btn {
  background-color: #3ac27d;
  border-color: #3ac27d;
  margin-right: 10px;
}

.fail-btn {
  margin-right: 10px;
}

.block-btn {
  color: #fff;
  background-color: #bab8b7;
  border-color: #bab8b7;
  margin-right: 10px;
}

.na-btn {
  color: #fff;
  background-color: #b24610;
  border-color: #b24610;
  margin-right: 10px;
}

/deep/ .ql-container.ql-snow {
  border: none;
  background: #fafafa;
  padding: 16px;
}
.review-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
